import { render, staticRenderFns } from "./v-pdf.vue?vue&type=template&id=60c02e31&scoped=true&"
import script from "./v-pdf.vue?vue&type=script&lang=js&"
export * from "./v-pdf.vue?vue&type=script&lang=js&"
import style0 from "./v-pdf.vue?vue&type=style&index=0&id=60c02e31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c02e31",
  null
  
)

export default component.exports